export { default as InventoryRequestEmailEdit } from './InventoryRequestEmailEdit';
